export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-shield-2bc26c007a034c042bcd084a074888bf.svg";